export const JiraWorkManagementLogoBrand = () => (
    <svg
        width="504"
        height="48"
        viewBox="0 0 504 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M51.665 8.47705H55.806V29.5021C55.806 35.0681 53.368 38.8871 47.663 38.8871C45.501 38.8871 43.845 38.519 42.694 38.105V34.1031C43.936 34.6091 45.455 34.885 46.972 34.885C50.469 34.885 51.664 32.769 51.664 29.779V8.47705H51.665Z"
            fill="#172B4D"
        />
        <path
            d="M63.3479 6.86719C64.9579 6.86719 66.1079 7.87919 66.1079 9.62819C66.1079 11.3772 64.9589 12.3882 63.3479 12.3882C61.7369 12.3882 60.5869 11.3762 60.5869 9.62819C60.5869 7.88019 61.7369 6.86719 63.3479 6.86719ZM61.3239 15.7002H65.2809V38.7032H61.3239V15.7002Z"
            fill="#172B4D"
        />
        <path
            d="M75.124 38.7031H71.26V15.7001H75.124V19.7491C76.458 17.0341 78.759 15.1031 83.268 15.3781V19.2421C78.207 18.7361 75.124 20.2551 75.124 25.1311V38.7031Z"
            fill="#172B4D"
        />
        <path
            d="M101.805 34.5617C100.333 37.5977 97.573 39.1627 94.031 39.1627C87.912 39.1627 84.83 33.9637 84.83 27.2007C84.83 20.7147 88.05 15.2397 94.491 15.2397C97.849 15.2397 100.426 16.7587 101.805 19.7487V15.6997H105.762V38.7027H101.805V34.5617ZM95.088 35.4817C98.631 35.4817 101.805 33.2277 101.805 28.1217V26.2807C101.805 21.1747 98.907 18.9207 95.548 18.9207C91.086 18.9207 88.785 21.8647 88.785 27.2007C88.785 32.7217 90.993 35.4817 95.088 35.4817Z"
            fill="#172B4D"
        />
        <path
            d="M116.108 8.47705H120.387L128.253 34.791L136.857 8.47705H141.732L150.336 34.791L158.203 8.47705H162.344L152.821 38.703H147.53L139.157 12.8931L130.784 38.703H125.632L116.109 8.47705H116.108Z"
            fill="#172B4D"
        />
        <path
            d="M162.338 27.1547C162.338 20.2547 166.387 15.2397 173.287 15.2397C180.142 15.2397 184.144 20.2547 184.144 27.1547C184.144 34.0547 180.142 39.1627 173.287 39.1627C166.387 39.1627 162.338 34.0567 162.338 27.1547ZM166.203 27.1547C166.203 31.5257 168.365 35.4817 173.287 35.4817C178.164 35.4817 180.279 31.5257 180.279 27.1547C180.279 22.7837 178.164 18.9207 173.287 18.9207C168.365 18.9207 166.203 22.7847 166.203 27.1547Z"
            fill="#172B4D"
        />
        <path
            d="M192.605 38.7031H188.742V15.7001H192.605V19.7491C193.939 17.0341 196.24 15.1031 200.75 15.3781V19.2421C195.689 18.7361 192.605 20.2551 192.605 25.1311V38.7031Z"
            fill="#172B4D"
        />
        <path
            d="M204.152 38.703V6.08496H208.109V26.466L218 15.7H223.152L212.341 27.017L223.611 38.703H218.23L208.109 27.937V38.703H204.152Z"
            fill="#172B4D"
        />
        <path
            d="M240.4 10.9621V38.703H236.259V8.47705H243.435L250.29 25.821L253.097 34.148L255.904 25.821L262.804 8.47705H269.474V38.703H265.333V11.2841L261.792 22.1861L255.12 38.703H251.118L244.54 22.1861L240.399 10.9611L240.4 10.9621Z"
            fill="#172B4D"
        />
        <path
            d="M291.691 34.5617C290.218 37.5977 287.459 39.1627 283.916 39.1627C277.797 39.1627 274.715 33.9637 274.715 27.2007C274.715 20.7147 277.936 15.2397 284.377 15.2397C287.734 15.2397 290.311 16.7587 291.691 19.7487V15.6997H295.648V38.7027H291.691V34.5617ZM284.974 35.4817C288.517 35.4817 291.691 33.2277 291.691 28.1217V26.2807C291.691 21.1747 288.793 18.9207 285.433 18.9207C280.972 18.9207 278.671 21.8647 278.671 27.2007C278.671 32.7217 280.878 35.4817 284.974 35.4817Z"
            fill="#172B4D"
        />
        <path
            d="M321.178 38.7027H317.221V24.8087C317.221 20.6677 315.565 18.8287 311.791 18.8287C308.111 18.8287 305.582 21.2667 305.582 25.9127V38.7027H301.625V15.6997H305.582V19.4717C307.053 16.7577 309.768 15.2397 312.85 15.2397C318.141 15.2397 321.178 18.8747 321.178 25.2227V38.7017V38.7027Z"
            fill="#172B4D"
        />
        <path
            d="M342.291 34.5617C340.818 37.5977 338.059 39.1627 334.516 39.1627C328.397 39.1627 325.315 33.9637 325.315 27.2007C325.315 20.7147 328.536 15.2397 334.977 15.2397C338.334 15.2397 340.911 16.7587 342.291 19.7487V15.6997H346.248V38.7027H342.291V34.5617ZM335.574 35.4817C339.117 35.4817 342.291 33.2277 342.291 28.1217V26.2807C342.291 21.1747 339.393 18.9207 336.033 18.9207C331.572 18.9207 329.271 21.8647 329.271 27.2007C329.271 32.7217 331.478 35.4817 335.574 35.4817Z"
            fill="#172B4D"
        />
        <path
            d="M367.729 34.5617C366.256 37.5977 363.497 39.1627 359.954 39.1627C353.882 39.1627 350.845 33.9637 350.845 27.2007C350.845 20.7147 354.019 15.2397 360.415 15.2397C363.772 15.2397 366.349 16.7587 367.729 19.7487V15.6997H371.592V36.6327C371.592 43.3957 368.418 47.9497 360.184 47.9497C356.319 47.9497 354.204 47.4437 351.995 46.7077V42.8437C354.526 43.6717 357.147 44.2237 360.001 44.2237C365.751 44.2237 367.73 41.1417 367.73 36.8627V34.5627L367.729 34.5617ZM361.012 35.4817C364.553 35.4817 367.729 33.2277 367.729 28.1217V26.2807C367.729 21.1747 364.831 18.9207 361.471 18.9207C357.008 18.9207 354.709 21.8647 354.709 27.2007C354.709 32.7217 356.916 35.4817 361.012 35.4817Z"
            fill="#172B4D"
        />
        <path
            d="M388.564 39.1627C379.962 39.1627 376.189 34.1937 376.189 27.1547C376.189 20.2087 380.054 15.2397 387.046 15.2397C394.13 15.2397 396.984 20.1627 396.984 27.1547V28.9497H380.191C380.744 32.8597 383.275 35.3897 388.703 35.3897C391.371 35.3897 393.625 34.8837 395.695 34.1477V37.7827C393.81 38.7947 390.912 39.1627 388.564 39.1627ZM380.146 25.5447H392.982C392.752 21.2667 390.82 18.8287 386.863 18.8287C382.675 18.8287 380.56 21.5427 380.146 25.5447Z"
            fill="#172B4D"
        />
        <path
            d="M421.227 38.7027H417.27V24.8087C417.27 20.6677 415.614 18.8287 411.84 18.8287C408.16 18.8287 405.631 21.2667 405.631 25.9127V38.7027H401.674V15.6997H405.631V19.4717C407.102 16.7577 409.817 15.2397 412.899 15.2397C416.809 15.2397 419.477 17.2187 420.628 20.8517C421.917 17.3097 424.999 15.2397 428.817 15.2397C433.969 15.2397 436.823 18.7357 436.823 25.2227V38.7017H432.866V25.9117C432.866 21.1737 431.21 18.8277 427.436 18.8277C423.756 18.8277 421.227 21.2657 421.227 25.9117V38.7017V38.7027Z"
            fill="#172B4D"
        />
        <path
            d="M453.332 39.1627C444.73 39.1627 440.957 34.1937 440.957 27.1547C440.957 20.2087 444.822 15.2397 451.814 15.2397C458.898 15.2397 461.752 20.1627 461.752 27.1547V28.9497H444.959C445.512 32.8597 448.043 35.3897 453.471 35.3897C456.139 35.3897 458.393 34.8837 460.463 34.1477V37.7827C458.578 38.7947 455.68 39.1627 453.332 39.1627ZM444.914 25.5447H457.75C457.52 21.2667 455.588 18.8287 451.631 18.8287C447.443 18.8287 445.328 21.5427 444.914 25.5447Z"
            fill="#172B4D"
        />
        <path
            d="M485.994 38.7027H482.037V24.8087C482.037 20.6677 480.381 18.8287 476.607 18.8287C472.927 18.8287 470.398 21.2667 470.398 25.9127V38.7027H466.441V15.6997H470.398V19.4717C471.869 16.7577 474.584 15.2397 477.666 15.2397C482.957 15.2397 485.994 18.8747 485.994 25.2227V38.7017V38.7027Z"
            fill="#172B4D"
        />
        <path
            d="M500.619 34.9758C501.539 34.9758 502.414 34.7908 503.103 34.6538V38.4718C502.414 38.6568 501.63 38.8398 500.435 38.8398C495.513 38.8398 493.121 35.9418 493.121 31.6628V19.3798H489.394V15.6988H493.121V10.8218H496.984V15.6988H503.103V19.3798H496.984V31.5708C496.984 33.5948 498.181 34.9748 500.619 34.9748V34.9758Z"
            fill="#172B4D"
        />
        <path
            d="M20.583 8.07913L14.887 30.5631C22.139 32.6121 27.922 29.9481 30.138 21.2001L33.462 8.07812H20.583V8.07913Z"
            fill="url(#paint0_linear_818_522)"
        />
        <path
            d="M12.879 38.4819L18.575 15.9979C11.323 13.9489 5.54 16.6129 3.324 25.3609L0 38.4819H12.879Z"
            fill="#1D7AFC"
        />
        <defs>
            <linearGradient
                id="paint0_linear_818_522"
                x1="13.2"
                y1="30.6461"
                x2="24.898"
                y2="16.5881"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#0055CC" />
                <stop offset="1" stopColor="#1D7AFC" />
            </linearGradient>
        </defs>
    </svg>
);
